import type { PromptNoun } from '@/lib/prompt-noun'

/** The draw prompt's keyword line, with the §5.0.2 v1.0.4 shared-keyword
 *  gloss beneath it when the caller resolved a noun. */
export function KeywordPrompt({
    keyword,
    promptNoun,
}: {
    keyword: string
    promptNoun?: PromptNoun
}) {
    return (
        <div className="flex flex-col items-center gap-3">
            <p className="font-serif text-h1 font-semibold text-ink">
                {keyword}
            </p>
            {promptNoun && (
                <p
                    aria-hidden="true"
                    className="font-serif text-meta tracking-[0.04em] text-muted-fg italic"
                >
                    the {promptNoun}
                </p>
            )}
        </div>
    )
}
